import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {kebabCase, snakeCase} from 'change-case';
import {useTranslate} from '@computerrock/formation-i18n';
import {arrowDownIcon, arrowUpIcon, DataRow, InteractiveIcon, Panel, useStyles} from '@ace-de/ui-components';

const MIAFormAidServicePanel = ({service, isDefaultExpanded = false}) => {
    const {cx} = useStyles();
    const {createTranslateShorthand, translate} = useTranslate();
    const translatePanel = createTranslateShorthand('mia_form_aid_service_panel');
    const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);

    if (!service) return null;

    return (
        <Panel
            title={(
                <div className={cx('global!ace-u-flex')}>
                    <p className={cx('global!ace-u-typography--variant-h2', 'global!ace-u-margin--right-32')}>
                        {translate(`global.service_type.${service.type.toLowerCase()}`)}
                    </p>
                    <InteractiveIcon
                        name={`expend-section-arrow-${kebabCase(service.type.toLowerCase())}`}
                        icon={isExpanded ? arrowUpIcon : arrowDownIcon}
                        onClick={() => setIsExpanded(!isExpanded)}
                    />
                </div>
            )}
        >
            {isExpanded && (
                <div>
                    <h2 className={cx('global!ace-u-padding--24-0')}>
                        {translatePanel('subtitle.case_data')}
                    </h2>
                    <DataRow
                        label={translatePanel('data_row_label.trip_purpose')}
                        qaIdent="trip-purpose"
                    >
                        {service.tripPurpose ? translate(`global.trip_purpose_type.${snakeCase(service.tripPurpose)}`) : '-'}
                    </DataRow>
                    <DataRow
                        label={translatePanel('data_row_label.end_of_repair')}
                        qaIdent="end-of-recovery-date-time"
                    >
                        {service.endOfRecoveryDateTime || '-'}
                    </DataRow>
                </div>
            )}
        </Panel>
    );
};

MIAFormAidServicePanel.propTypes = {
    service: PropTypes.object,
    isDefaultExpanded: PropTypes.bool,
};

MIAFormAidServicePanel.defaultProps = {
    service: null,
    isDefaultExpanded: false,
};

export default MIAFormAidServicePanel;
